export default __webpack_public_path__ + "static/media/puesc.9be3b5d2.svg";